// MIT License - Copyright (c) 2026 Doug McNall
import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null,
      errorInfo: null 
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
    this.setState({ errorInfo });
    
    // Here you could send to error tracking service (Sentry, LogRocket, etc.)
    // Example: logErrorToService(error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="error_boundary">
          <div className="error_boundary_content">
            <h2>🌶️ Oops! Something went wrong</h2>
            <p>We're sorry for the inconvenience. The page encountered an error.</p>
            
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <details className="error_details">
                <summary>Error Details (Development Only)</summary>
                <pre>{this.state.error.toString()}</pre>
                {this.state.errorInfo && (
                  <pre>{this.state.errorInfo.componentStack}</pre>
                )}
              </details>
            )}
            
            <div className="error_actions">
              <button 
                onClick={() => window.location.href = '/shop'}
                className="button button_primary"
              >
                Go to Home
              </button>
              <button 
                onClick={() => window.location.reload()}
                className="button button_secondary"
              >
                Refresh Page
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
